import SectionHeader from '../SectionHeader';
import {
  Grid,
  GridItem,
  Image,
  Button,
  Flex,
  Box,
  Icon, useStyleConfig, useMediaQuery,
} from '@chakra-ui/react';
import SubmitModal from '../../components/Modal/index';
import { handleClose } from '../../components/Modal/utils';
import SummaryBox from './SummaryBox';
import EditableBox from './EditableBox';
import { addResume, checkSummaryOpen } from './utils';
import JobIndustryModal from '../../components/Modal/JobIndustryModal';
import { RiAddCircleLine } from 'react-icons/ri';
import { checkIsSummaryBox } from '../MultiSection/utils';

const Start = ({ props, formikProps }) => {
  const navSection =
    props.navSections[props.stateProps.sectionData.sectionName];
  props.formikProps = formikProps;
  const multiStyles = props.stateProps.multisectionStyles;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  const jobSeekerData = formikProps.values.jobSeekerData;
  const isMobile = useMediaQuery('(max-width: 768px)',{ssr:false});
  checkSummaryOpen(props);
  return (
    <>
      <SectionHeader navSection={navSection} props={props} />
      <Grid
        templateAreas={[`"docs"`, `"docs"`, `"docs"`, `"hero docs"`]}
        gridTemplateColumns={[
          'repeat(1, 1fr)',
          'repeat(1, 1fr)',
          'repeat(1, 1fr)',
          '30% 70%',
        ]}
      >
        <GridItem area={[null, null, null, 'hero']}>
          <Image
            sx={{
              width: [0, 0, 0, 'auto'],
            }}
            src={navSection.hero}
          />
        </GridItem>
        <GridItem area={'docs'}>
          <Box display='flex' justifyContent='flex-end' >
            {isMobile[0] && (

              <Button
                sx={{ ...buttonStyles.secondary, ...buttonStyles.newResume }}
                margin='0 auto 1rem auto'
                onClick={() => {
                  addResume(props, {});
                }}
              >
                <Icon as={RiAddCircleLine} boxSize={5} />
                &nbsp;&nbsp;New Resume
              </Button>
            )}
            {!isMobile[0] &&  (

              <Button
              sx={{ ...buttonStyles.secondary, ...buttonStyles.newResume }}
            onClick={() => {
              addResume(props, {});
            }}
          >
            <Icon as={RiAddCircleLine} boxSize={5} />
            &nbsp;&nbsp;New Resume
          </Button>
              )
            }
          </Box>
          <Grid
            templateColumns={[
              'repeat(1, 1fr)',
              'repeat(1, 1fr)',
              'repeat(2, 1fr)',
            ]}
            gap={4}
          >
            <SubmitModal
              stateProps={props.stateProps}
              formikProps={formikProps}
              handleClose={handleClose}
              message_raw="" />

            {Object.values(jobSeekerData).map((secPart, index) => {
              //ALERT jobSeekerData after delete of the next to last resume only
              // comes through with an empty object as the last element in the
              // array. this is temp fix below but root cause should be found.
              if (!secPart?.contact) {
                return null;
              }
              if (checkIsSummaryBox(props.stateProps, index)) {
                return (
                  <SummaryBox props={props} formikProps={formikProps} index={index} styles={multiStyles} />
                );
              }
              return (
                <>
                  <EditableBox props={props} index={index} />
                  <JobIndustryModal props={props} resumeIndex={index} />
                </>
              );

            })}

          </Grid>
        </GridItem>
      </Grid>
    </>
  );
};

export default Start;
/*

 */